import React from 'react';

import useArticlePaywallProps from '@hooks/useArticlePaywallProps';
import { LeadType } from '@utils/enums';

import PaywallBanner from './Banner';
import PaywallFull from './Full';

export enum PaywallType {
  Full = 'full',
  Banner = 'banner',
}

export interface PaywallProps {
  articleId?: number;
  briefingGuid?: string;
  buttonText?: string;
  leadType?: LeadType;
  offerLink?: string;
  offerCode?: string;
  isPro?: boolean;
  paywallType?: PaywallType;
  shareGuid?: string;
  subtitle?: string;
  title?: string;
  trackingProps?: { [key: string]: string };
  unlockContent?: boolean;
}

export const getPaywallLayout = (type: string) => {
  switch (type) {
    case PaywallType.Full:
      return PaywallFull;
    case PaywallType.Banner:
      return PaywallBanner;
    default:
      return null;
  }
};

const Paywall = (paywallProps: PaywallProps): JSX.Element => {
  const { articlePaywallProps, isArticlePaywallPropsLoading } = useArticlePaywallProps({
    articleId: paywallProps.articleId,
    offerCode: paywallProps.offerCode,
    enableQuery: !paywallProps.title,
  });
  const paywallType = paywallProps.title
    ? paywallProps.paywallType
    : articlePaywallProps?.paywallProps?.paywallType;
  const PaywallLayout = getPaywallLayout(paywallType);
  const paywallLayoutProps = paywallProps.title ? paywallProps : articlePaywallProps?.paywallProps;

  return isArticlePaywallPropsLoading ? null : <PaywallLayout {...paywallLayoutProps} />;
};

export default Paywall;
